import React, { Component } from 'react'
import PropTypes from 'prop-types'

const defaultState = {
  form: { email: '' },
}

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'FASearchFormContainer'

    static propTypes = {
      filters: PropTypes.object.isRequired,
      redirectToSearch: PropTypes.func.isRequired,
      router: PropTypes.object,
      setFilters: PropTypes.func.isRequired,
      shouldRedirectToSearch: PropTypes.bool,
      query: PropTypes.object,
    }

    static defaultProps = {
      shouldRedirectToSearch: false,
    }

    state = { form: this.props.filters }

    componentDidMount() {
      this.setSearch(this.props)
    }

    componentWillReceiveProps(nextProps) {
      this.setSearch(nextProps)
    }

    handleInputChange = (e, { name, value }) => {
      this.setState(prevState => ({
        form: { ...prevState.form, [name]: value },
      }))
    }

    handleReset = e => {
      const { setFilters } = this.props

      e.preventDefault()

      setFilters(defaultState.form)

      this.setState(defaultState)
    }

    handleSubmit = e => {
      const { redirectToSearch, setFilters, shouldRedirectToSearch } = this.props

      const { form } = this.state

      if (e) {
        e.preventDefault()
      }

      if (shouldRedirectToSearch) {
        redirectToSearch(form.email)
      } else {
        setFilters(form)
      }
    }

    removeQueryFromUrl = () => {
      const { router } = this.props

      router.replace('/familyAlbum/search')
    }

    setSearch = props => {
      const { query, setFilters } = props

      if (query && query.email) {
        setFilters({ email: query.email })

        this.setState({ form: { email: query.email } }, this.removeQueryFromUrl)
      }
    }

    render() {
      const { form } = this.state

      return (
        <WrappedComponent
          form={form}
          handleInputChange={this.handleInputChange}
          handleReset={this.handleReset}
          handleSubmit={this.handleSubmit}
        />
      )
    }
  }

  return Container
}
